import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/user/UserContext";
import { PageWrapper } from "../UI/Grid";
import Table from "../UI/Table";

const Administration = () => {
  const navigate = useNavigate();
  const { activeUser } = useContext(UserContext);
  const { pid, roleLevel } = activeUser || {};

  let gridData = useMemo(
    () => [
      {
        title: "Users",
        path: "/Users",
        iconName: "faUsers",
      },
      {
        title: "Groups",
        path: `/Groups/${pid}`,
        iconName: "faUserGroup",
      },
      {
        title: "Products",
        path: "/Products",
        iconName: "faBoxesStacked",
      },
      {
        title: "Product Lists",
        path: `/ProductLists/${pid}`,
        iconName: "faTableList",
      },
      {
        title: "Customers",
        path: `/Customers/${pid}`,
        iconName: "faIdCard",
      },
      // {
      //   title: "Addresses",
      //   path: "/Addresses",
      //   iconName: "faAddressBook",
      // },

      {
        title: "Themes",
        path: `/Themes/${pid}`,
        iconName: "faPalette",
      },
      {
        title: "RMAs",
        path: `/RMAs/${pid}`,
        iconName: "faTags",
      },
    ],
    [pid]
  );

  if (roleLevel >= 5)
    gridData = [
      ...gridData,
      {
        title: "Status Types",
        path: "/StatusTypes",
        iconName: "faTimeline",
      },
      {
        title: "Platform Settings",
        path: `/Platforms/edit/${pid}`,
        iconName: "faGears",
      },
      {
        title: "Imports",
        path: `/Imports`,
        iconName: "faFileImport",
      },
      {
        title: "All Orders",
        path: `/Orders/${pid}`,
        iconName: "faTruckFast",
      },
      {
        title: "All Quotes",
        path: `/Quotes/${pid}`,
        iconName: "faFileContract",
      },
    ];
  if (roleLevel === 9)
    gridData = [
      ...gridData,
      {
        title: "Role Management",
        path: `/Role/${pid}`,
        iconName: "faIdCardClip",
      },
      {
        title: "Platforms",
        path: `/Platforms`,
        iconName: "faPeopleRoof",
      },
      {
        title: "Issue Reports",
        path: "/IssueReports",
        iconName: "faBugs",
      },
    ];

  return (
    <PageWrapper>
      <Table
        title="Administration"
        hideCreate
        hideBack
        gridData={gridData}
        onCardClick={(item) => navigate(item.path)}
        hidePager
        hideSearch
        forceGrid
        hideToggle
        hideProperties
      />
    </PageWrapper>
  );
};

export default Administration;
